/**
 * Generates an array of options for use in an antd dropdown or select component.
 *
 * @param data An array of objects, where each object represents an option.
 * @param labelKey The key in each object that corresponds to the option's label.
 * @param valueKey The key in each object that corresponds to the option's value.
 * @returns An array of objects, where each object has a `label` and `value` property, or an empty array if the input data is null or undefined.
 */
const getOptions = (data: any[], labelKey: string, valueKey: string) =>
  data?.map((item) => ({
    label: item[labelKey],
    value: item[valueKey],
  })) || [];

export default getOptions;
